import { useCallback, useEffect, useRef, useState } from 'react';

// How long after the last scroll event the element still counts as scrolling.
const SETTLE_DELAY_MS = 800;

// True while the user is scrolling an element and briefly after, so its scrollbar can be shown
// more prominently during the gesture. Wire `onScroll` to the scrolling element.
export function useIsScrolling() {
    const [isScrolling, setIsScrolling] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    const onScroll = useCallback(() => {
        setIsScrolling(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setIsScrolling(false), SETTLE_DELAY_MS);
    }, []);

    useEffect(() => () => clearTimeout(timer.current), []);

    return { isScrolling, onScroll };
}
